import { useLingui } from '@lingui/react';

/**
 * Replaces the generic questionnaire error (carleadCreation.error.selectAnswer) with a
 * field-specific wording for BOUGHT_OR_ORDERED_CAR. Reachability / required logic stays in the
 * wrapped questionnaire validator. Must be listed BEFORE useFormQuestionnaireProps in
 * useCreateNormalCarleadForm — createCustomValidators compose with reduceRight, so the first
 * entry runs last and wins.
 *
 * @returns {{ createCustomValidators: Array<Function> }}
 */
export const useBoughtOrOrderedCarValidation = () => {
  const {
    i18n
  } = useLingui();
  return {
    createCustomValidators: [function boughtOrOrderedCarValidator({
      validators
    }) {
      const baseValidator = validators.BOUGHT_OR_ORDERED_CAR;

      // Hook listed after useFormQuestionnaireProps → nothing to wrap. Keep the questionnaire
      // rule instead of silently making the field optional.
      if (!baseValidator) {
        return validators;
      }
      return {
        ...validators,
        BOUGHT_OR_ORDERED_CAR({
          value,
          values,
          locale,
          errorMessages,
          fieldName
        }) {
          const base = baseValidator({
            value,
            values,
            locale,
            errorMessages,
            fieldName
          });
          if (base === errorMessages.selectAnswer) {
            return i18n._('carleadCreation.error.boughtOrOrderedCar');
          }
          return base;
        }
      };
    }]
  };
};